import './index.less';
import classnames from 'classnames';

export type RevxCardTitleProps = {
  children?: React.ReactNode;
  className?: string;
  width?: number | string;
  height?: number | string;
  borderRadius?: number | string;
  border?: string;
  style?: object;
};

export const RevxCardTitle = (props: RevxCardTitleProps) => {
  return (
    <div
      className={classnames('revx-card-title', props.className)}
      style={{
        width: props.width,
        height: props.height,
        borderRadius: props.borderRadius,
        border: props.border,
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};
